import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { FormControl } from '@angular/forms'
import { SliderStrengthEnum, sliderStrengthMap } from './slider-strengths'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { distinctUntilChanged, startWith } from 'rxjs'

@UntilDestroy()
@Component({
  selector: 'gb-range-slider',
  templateUrl: './gb-range-slider.component.html',
  styleUrls: ['./gb-range-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbRangeSliderComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() control!: FormControl
  // lowest value in the range
  @Input() min = 0
  // greatest value in the range
  @Input() max = 100
  // step interval
  @Input() step = 1
  // slider label
  @Input() label = ''

  @Output() sliderReady = new EventEmitter<void>()

  @ViewChild('slider') slider!: ElementRef

  // slider progress percentage
  progress = 0
  // slider css class
  cssClass = SliderStrengthEnum.None
  // is touch screen device
  isTouch = false

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
  }

  ngAfterViewInit(): void {
    this.sliderReady.emit()
    this.control.valueChanges
      .pipe(untilDestroyed(this), distinctUntilChanged(), startWith(undefined))
      .subscribe((value) => {
        // type="range" requires number otherwise defaults to middle.
        // Set slider value to min if control has no value
        if (!value) this.slider.nativeElement.value = this.min
        this.updateSliderOnChange()
      })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['min'].isFirstChange()) {
      this.updateSliderOnChange()
    }
  }

  updateSliderOnChange(): void {
    this.setProgress()
    this.setSliderClass()
    this.cdr.detectChanges()
  }

  setProgress(): void {
    const progress = ((this.control.value - this.min) / (this.max - this.min)) * 100
    // clamp progress to number between 0 and 100
    this.progress = Math.max(0, Math.min(100, progress))
  }

  setSliderClass(): void {
    if (+this.control.value < this.min) {
      this.cssClass = SliderStrengthEnum.None
      return
    }

    for (let i = 0; i < sliderStrengthMap.length; i++) {
      if (this.progress < sliderStrengthMap[i].min) break
      this.cssClass = sliderStrengthMap[i].value
    }
  }
}
